import { applyOverrides, counterpartyTCCard } from '../../../shared';

export const sellerTCCard = applyOverrides(counterpartyTCCard, {
  id: 'sellerSideContacts.sellerTC',
  innerTitle: "Landlord's Transaction Coordinator",
  outerTitle: "Landlord's Transaction Coordinators",
  addableTitle: "Landlord's Transaction Coordinator",
});
